import { useCallback } from 'react'

import { useTheme } from '@/components/theme-provider'

export const CATEGORY_COLORS: Record<string, string> = {
  health: '#FF6452',
  career: '#3DA9FC',
  mind: '#a8ff3e',
  finance: '#FFB020',
  relationships: '#FF5C8A',
  creative: '#A66BFF',
}

const MIND = '#a8ff3e'
const MIND_LIGHT = '#65a30d'

const TEXT_VAR: Record<string, string> = {
  '#ff6452': 'var(--health-text)',
  '#3da9fc': 'var(--career-text)',
  [MIND]: 'var(--mind-text)',
  [MIND_LIGHT]: 'var(--mind-text)',
  '#ffb020': 'var(--finance-text)',
  '#ff5c8a': 'var(--relationships-text)',
  '#a66bff': 'var(--creative-text)',
}

// A category colour rendered as text: resolves to the theme's readable shade
// (darker on white, brand colour on dark). Unknown colours pass through.
export function categoryTextColor(color: string): string {
  return TEXT_VAR[color.toLowerCase()] ?? color
}

// A category colour used as a fill. Resolved to a hex rather than var(--mind)
// because call sites append alpha (`${color}20`); mirrors --mind in globals.css.
export function categoryFill(color: string, isDark: boolean): string {
  return !isDark && color.toLowerCase() === MIND ? MIND_LIGHT : color
}

export function useCategoryFill(): (color: string) => string {
  const { resolvedTheme } = useTheme()
  const isDark = resolvedTheme !== 'light'
  return useCallback((color: string) => categoryFill(color, isDark), [isDark])
}
